// Resolve the backend API base URL.
//
// Priority:
//   1. Runtime config from /env.js (window.__ENV__.API_BASE), injected by the
//      container entrypoint so one image can target different backends.
//   2. Build-time CRA env vars (REACT_APP_*) or the localhost default.
//
// This is a function, not a constant, so it is evaluated when a request is
// made. That guarantees the runtime config is picked up even if the env.js
// script tag happens to load after the application bundle.

const cleanBase = (value) => String(value || '').replace(/\/+$/, '');

export const getApiBaseUrl = () => {
  const runtimeApi =
    typeof window !== 'undefined' && window.__ENV && window.__ENV__.API_BASE
      ? window.__ENV__.API_BASE
      : null;
  const svcUrl =
    process.env.REACT_APP_SERVICE_URL_BACKEND ||
    process.env.REACT_APP_SERVICE_URL_BACKEND_ALT;
  const svcFqdn = process.env.REACT_APP_SERVICE_FQDN_BACKEND;
  const backendPort = process.env.REACT_APP_BACKEND_PORT || '5001';

  let base;
  if (runtimeApi) {
    base = runtimeApi;
  } else if (svcUrl) {
    base = svcUrl;
  } else if (svcFqdn) {
    base = `https://${svcFqdn}`;
  } else {
    base = `http://localhost:${backendPort}`;
  }

  const trimmed = cleanBase(base);
  return trimmed.endsWith('/api') ? trimmed : `${trimmed}/api`;
};

// Convenience export for callers that want a string immediately.
export const API_BASE_URL = getApiBaseUrl();

export default API_BASE_URL;
